import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, Output, SimpleChanges } from "@angular/core";
import { filter, first, Observable, Subscription, take } from "rxjs";
import { LocationDTO } from "../../models/LocationDTO";
import { LocationsService } from "../../services/Locations.service";
import { GeoClustersFrecuencyPlacesService } from "../../services/GeoClustersFrecuencyPlaces.service";
import { MediaMatcher } from "@angular/cdk/layout";
import { Router } from "@angular/router";
import { MapHelperService } from "src/services/map-helper.service";
import { LocationsMapService } from "../../services/Locations-Map.service";
import { PanelLocationsService } from "../../services/Panel-Locations.service";
import { ToolCarsSelectorService } from "../../services/Tool-Cars-Selector.service";
import { PanelInternalLayerService } from "../../services/Panel-Internal-Layer.service";
import { CallBackService } from "src/app/features/callback/services/CallBack.service";
import { PopupDetailGeoposService } from "src/app/features/routeMap/services/Popup-Detail-Geopos.service";
import { TutorialService } from "src/app/features/shared/features/tutorial/services/tutorial.service";
import { EstatusJSON } from "src/app/features/shared/models/EstatusJSON";
import { SignalUser } from "src/app/features/shared/models/SignalUser/SignalUser";
import { MapService } from "src/app/features/shared/services/Map.service";
import { SessionService } from "src/app/features/shared/services/Session.service";
import { SignalRService } from "src/app/features/shared/services/Signal-R.service";
import { isMap } from "util/types";
import { LayerService } from "../../services/Layers.service";
@Component({
  selector: "locations-map",
  templateUrl: "./locations-map.component.html",
  styleUrls: ["./locations-map.component.css"],
})
export class LocationsMapComponent implements OnInit, OnDestroy {
  @Output() $ItemsMap: string[] = [];
  @Output() $isBuildingMap: Observable<boolean>;
  @Output() public _isVisibleDetails: boolean;
  @Input() public gasLayerEmitter: boolean;
  public _isVisiblePanelLocations: boolean;
  public _isVisiblePinbar: boolean;
  public $isVisibleDetails: Observable<boolean>;
  public _baseMap: string = "day";
  public _baseMapText: string = "Modo Nocturno";
  public _UpdateBtnText: string = "Tiempo Real";
  public _IsAuthorized: boolean = false;
  public _isVisibleNavBar: boolean;

  public recargarHora: number = 0;
  private _CENTER_LAT = "24.226252";
  private _CENTER_LNG = "-103.0266765";
  private _CENTER_ZOOM = "4.5";

  PinSelected: LocationDTO;
  $DataGeoJson: Observable<any> = new Observable<any>();
  IsAuthenticated: boolean;
  isLoadingPanel: boolean;
  private _isVisiblePanelLayers: boolean;
  signalUser: SignalUser = new SignalUser();
  isPaintingMap = false;

  //Variables para tooltip
  intersectMsg: string = "Selecciona varios puntos en el mapa para crear la SELECCIÓN DE UNIDADES. Para finalizar da click derecho sobre el mapa.";

  //variables para panel de streetView
  showStreetViewBox = false;
  streetViewBoxTitle = 'Cargando...';
  descriptionCords = { y: 0, x: 0 };
  streetViewBoxDescription = '';

  loadingTimeOut: any;
  public isLoading: boolean = true;
  public $isLoading: Observable<boolean> = new Observable<boolean>();
  isVisiblePanel: boolean;
  $isVisiblePanel: Observable<boolean> = new Observable<boolean>();

  private Empty_GeoJson: any = {
    type: "FeatureCollection",
    features: [],
  };
  IdInterval: any;
  subscriber: any;

  subscription_GetLoading: Subscription;
  subscription_OnFocusPin: Subscription;
  subscription_IsVisibleDetails: Subscription;
  subscription_CheckAuthentication: Subscription;
  subscription_GetAPIVersion: Subscription;
  subscription_SetLocationsGeoJSON: Subscription;
  subscription_GetByIdentifier: Subscription;
  Suscription_getOnUpdate: Subscription;
  Subscription_GetBlockingState: Subscription;
  Subscription_GetMapMainSource: Subscription;
  Subscription_isVisiblePanel: Subscription;

  isAdmin: boolean;
  isMapUnified: boolean;
  subscription_dataGeojson: Subscription;

  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;

  constructor(
    private locationsService: LocationsService,
    public locationsMapService: LocationsMapService,
    public geoClustersFrecuencyCatalogService: GeoClustersFrecuencyPlacesService,
    public mapService: MapService,
    private popupDetailGeoposService: PopupDetailGeoposService,
    private sessionService: SessionService,
    private callbackService: CallBackService,
    private mapHelperService: MapHelperService,
    private router: Router,
    public panelLocationsService: PanelLocationsService,
    private signalRService: SignalRService,
    public locationService: LocationsMapService,
    private panelInternalLayerService: PanelInternalLayerService,
    public toolCarSelectorService: ToolCarsSelectorService,
  private changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private tutorialService: TutorialService,
    public layerService: LayerService

  ) {
    this.mobileQuery = media.matchMedia("(min-width: 760px)");
  this._mobileQueryListener = () => this.changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);

    this._isVisiblePinbar = true;
    this._isVisiblePanelLayers = false;


    this.subscription_GetLoading = this.locationsService
      .getLoading()
      .subscribe((data: boolean) => {
        this.isLoading = data;

        if(this.isLoading){
          if (this.loadingTimeOut)
            clearTimeout(this.loadingTimeOut);
          this.loadingTimeOut =setTimeout(() => {
            this.locationsService.setLoading(false);
          }, 10000);
        }else{
          if (this.loadingTimeOut)
            clearTimeout(this.loadingTimeOut);
        }
      });
    this.locationsService.setLoading(true);

    this.$isVisibleDetails = this.popupDetailGeoposService.checkVisibilityPopup();
    this.subscription_IsVisibleDetails = this.$isVisibleDetails.subscribe(
      (data) => {
        this._isVisibleDetails = data;
      }
    );
  }

  actualizarHora() {
    this.recargarHora = this.recargarHora++;
  }
  async ngOnInit(): Promise<void> {
    this.callbackService.isNeededCallback();
    this.StartMap();
    this.CheckingSourceURL();
    this.Suscription_getOnUpdate = this.signalRService.getOnUpdateLocationActive().subscribe((data) => {
      const location = { identifier: data };
      console.log("signal2",location);
      this.onFocusPin(location);
    });
    this.mobileQuery.removeListener(this._mobileQueryListener);

    this.Subscription_GetMapMainSource = this.mapHelperService.mainSource$.pipe(
                filter(location => location && location.isMainSourceReady && location.isStyleReady) ).subscribe(async location => {
      if (location && location.isMainSourceReady && location.isStyleReady && !this.isPaintingMap) {
        await this.PaintLocations();
        this.locationsService.setLoading(false);
      }
    });
  }

  ngAfterViewInit(): void {
    if (!this.mobileQuery.matches) {
      this.panelLocationsService.setVisibilityPanel(false);
    }else{
      this.panelLocationsService.setVisibilityPanel(true);
    }

    this.mapHelperService.infoBoxClick.next(null);
    this.mapHelperService.infoBoxClick$.subscribe(location => {
      if (location) {
        this.streetViewBoxDescription = `${location.lat.toFixed(5)}, ${location.lng.toFixed(5)}`;
        this.descriptionCords = { y: location.lat, x: location.lng };
        this.showStreetViewBox = true;
        this.streetViewBoxTitle = 'Cargando...';
        this.mapHelperService.GetDirection(this.descriptionCords.y, this.descriptionCords.x).subscribe(direction => {
          this.streetViewBoxTitle = direction;
        });
      }
    });

    this.$isVisiblePanel = this.panelLocationsService.getVisibilityPanel();
    this.Subscription_isVisiblePanel = this.$isVisiblePanel.subscribe((element) => {
      setTimeout(() => {
        this.isVisiblePanel = element;
        if (this.isVisiblePanel != undefined && this.isVisiblePanel == true) {
          setTimeout(() => {
            this.tutorialService.startTutorial(["panelLocationTutorial"]);
          }, 1000);
        }
        try { this.changeDetectorRef.detectChanges(); } catch (e) { /* noop */ }
      }, 0);
    });

      this.tutorialService.startTutorial(["mainTutorial"]);
  }


  ngOnDestroy() {
    if (this.subscription_GetLoading)
      this.subscription_GetLoading.unsubscribe();
    if (this.subscription_OnFocusPin)
      this.subscription_OnFocusPin.unsubscribe();
    if (this.subscription_IsVisibleDetails)
      this.subscription_IsVisibleDetails.unsubscribe();
    if (this.subscription_GetAPIVersion)
      this.subscription_GetAPIVersion.unsubscribe();
    if (this.subscription_GetByIdentifier)
      this.subscription_GetByIdentifier.unsubscribe();
    if (this.Suscription_getOnUpdate)
      this.Suscription_getOnUpdate.unsubscribe();
    if (this.Subscription_GetBlockingState)
      this.Subscription_GetBlockingState.unsubscribe();
    if (this.subscription_dataGeojson)
      this.subscription_dataGeojson.unsubscribe();
    if (this.Subscription_GetMapMainSource)
      this.Subscription_GetMapMainSource.unsubscribe();
    if (this.Subscription_isVisiblePanel)
      this.Subscription_isVisiblePanel.unsubscribe();
  }

  checkAPI(): any {
    this.subscription_GetAPIVersion = this.sessionService
      .getAPIversion()
      .subscribe(
        (data) => {
          if (data != null) return true;
        },
        (error) => {
          //Error callback
          console.error("error caught in component");
          return false;
        }
      );
  }

  CheckingSourceURL() {
    this.sessionService.CheckURLSource();
    this._isVisibleNavBar = this.sessionService.isMapix;
  }

  async PaintLocations(){
    this.isPaintingMap = true;
    var isMapPainted = this.locationsMapService.paintMainGeoJsonData(this.locationsMapService.mainGeoJsonData);
    var attempts = 0;
    while(!isMapPainted && attempts < 10){
      console.log("Attempting to paint main GeoJSON data", isMapPainted, this.locationsMapService.mainGeoJsonData, attempts + 1);
      await new Promise(resolve => setTimeout(resolve, 500));
      this.locationsService.setLoading(true);
      await this.locationsMapService.GetLocations();
      isMapPainted = this.locationsMapService.paintMainGeoJsonData(this.locationsMapService.mainGeoJsonData);
      attempts++;
    }
    this.locationsService.setLoading(false);
    this.panelInternalLayerService.isActiveLayer = true;
    this.panelInternalLayerService.isFilterLayer = false;
    this.panelInternalLayerService.onToggleLayerActivos(true);
    this.panelInternalLayerService.onToggleLayerFiltros(false);
    this.isPaintingMap = false;
  }

  async GetLocationsFilter(filters: any[]) {
    this.locationsMapService.filterGeoJsonData = null;
    var isMapPainted = this.locationsMapService.paintFilterGeoJsonData(this.locationsMapService.filterGeoJsonData);
    var attempts = 0;
    if (!isMapPainted && attempts < 10) {
      await new Promise(resolve => setTimeout(resolve, 500));
      this.locationsService.setLoading(true);
      await this.locationsMapService.GetLocationsFilter(filters);
      isMapPainted = this.locationsMapService.paintFilterGeoJsonData(this.locationsMapService.filterGeoJsonData);
      attempts++;
    }
    this.panelInternalLayerService.isActiveLayer = false;
    this.panelInternalLayerService.isFilterLayer = true;
    this.panelInternalLayerService.onToggleLayerActivos(false);
    this.panelInternalLayerService.onToggleLayerFiltros(true);
  }

  async GetLocationsAvailabilityFilter(filters: any, initialDate: string, finalDate: string, idLocationCategories: number[]) {
    var isMapPainted = this.locationsMapService.paintFilterGeoJsonData(this.locationsMapService.filterGeoJsonData);
    if (!isMapPainted) {
      this.locationsService.setLoading(true);
      await this.locationsMapService.GetLocationsAvailabilityFilter(filters, initialDate, finalDate, idLocationCategories);
      isMapPainted = this.locationsMapService.paintFilterGeoJsonData(this.locationsMapService.availabilityFilterGeoJsonData);
      this.locationsService.setLoading(false);
    }
    this.panelInternalLayerService.isActiveLayer = false;
    this.panelInternalLayerService.isFilterLayer = true;
    this.panelInternalLayerService.onToggleLayerActivos(false);
    this.panelInternalLayerService.onToggleLayerFiltros(true);
  }

  StopRecalculateCoords() {
    clearInterval(this.IdInterval);
  }

  onFocusPin(location: any) {
    this.mapHelperService.onFocusPin(location.identifier);
  }

  async onFilterMap(filters: any) {
    console.log("FILTERS", filters);
    
    if (filters.normalFilter != null) {

      this.toolCarSelectorService.startDate = null;
      this.toolCarSelectorService.endDate = null;
      if (filters.normalFilter.selected.length == 0) {
        await this.PaintLocations();
      } else {
        await this.GetLocationsFilter(filters.normalFilter.selected);
      }
    }else{
      if (filters.availabilityFilter.startDate == null || filters.availabilityFilter.endDate == null) {
        this.toolCarSelectorService.startDate = null;
        this.toolCarSelectorService.endDate = null;
        await this.PaintLocations();
      } 
      else {
        this.toolCarSelectorService.startDate = filters.availabilityFilter.startDate;
        this.toolCarSelectorService.endDate = filters.availabilityFilter.endDate;
        await this.GetLocationsAvailabilityFilter(filters.availabilityFilter.selected, filters.availabilityFilter.startDate.toISOString(), filters.availabilityFilter.endDate.toISOString(), filters.availabilityFilter.idLocationCategories);
      }
    }
    this.mapHelperService.FlyToCamera(
      this._CENTER_LAT,
      this._CENTER_LNG,
      this._CENTER_ZOOM,
      0
    );
  }
  
  onPinBarClicked($event: any) {
    console.log("evento pin");
    console.log($event);
    if ($event == "locations")
      this._isVisiblePanelLocations = !this._isVisiblePanelLocations;
    if ($event == "layers")
      this._isVisiblePanelLayers = !this._isVisiblePanelLayers;
  }

  StartMap() {
    this._isVisiblePinbar = true;
    this.isLoading = false;
    console.log(
      "*****************************************START MAP *************************************"
    );
    this.locationsService.setLoading(true);
    setTimeout(() => {
      this.locationsService.setLoading(false);
    }, 10000);
    this.mapHelperService.onLoadMapLocations();
  }

  onToolTipVisibilityChange(isVisible: boolean) {
    this.toolCarSelectorService.isCarSelectionToolTipVisible = isVisible;
  }

  closeInfoBox() {
    this.streetViewBoxDescription = '';
    this.descriptionCords = { y: 0, x: 0 };
    this.showStreetViewBox = false;
    this.mapHelperService.mapClickMarker.remove();
  }

  openStreetView() {
    this.mapService.loadStreetView(this.descriptionCords.x.toFixed(5), this.descriptionCords.y.toFixed(5));
  }

}
